const getApiUrl = (): string => {
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
    return `${globalThis.location.origin}/api`
  }
  switch (globalThis.location.origin) {
    case 'https://proveadmin.sample-dev.mattilsynet.io':
      return 'https://sample.sample-dev.mattilsynet.io'
    case 'https://proveadmin.sample-training.mattilsynet.io':
      return 'https://sample.sample-training.mattilsynet.io'
    case 'https://proveadmin.sample.mattilsynet.io':
      return 'https://sample.sample.mattilsynet.io'
    default:
      return `${globalThis.location.origin}/api`
  }
}
export const BASE_URL = getApiUrl()
